import chef1 from '../imgs/chef1.jpg';
import chef2 from '../imgs/chef2.jpg';

export const chefs = [
	{
		img: chef1,
		alt: 'Chef',
		name: 'Ferran Adrià',
	},
	{
		img: chef2,
		alt: 'Chef',
		name: 'Mario Batali',
	},
];
